import './archive.css';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Upload from './Upload';
// import trackAccess from '../../Data/track-access.json';
import Alert from '@mui/material/Alert';

export default function Archive() {

    const [trackAccess, setTtrackAccess] = useState();
    const [newTrackAccess, setNewTrackAccess] = useState();
    const [fetchError, setFetchError] = useState(false);

    useEffect(() => {
        // axios.get("http://localhost:3021/track/getUsernames")
        axios.get("https://atci.lkm.qa.accenture.com/qa-apis/track/getUsernames")
            .then((res) => {
                setTtrackAccess(res.data);
               
            })
            .catch((err) => {
                setFetchError(true);
                console.log(err)})
    }, [])

    const lowerize = obj =>
        Object.keys(obj).reduce((acc, k) => {
            acc[k.toLowerCase()] = obj[k];
            return acc;
        }, {});

    useEffect(() => {
        let techTrackAccess = trackAccess && lowerize(trackAccess?.["technology-wise-full-access"])
        setNewTrackAccess(techTrackAccess);
        // trackAccess && setTtrackAccess(...trackAccess, "technology-wise-full-access" = newTrackAccess);
       
    }, [trackAccess]);

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    let ipsLoggedInEnterpriseId = '';
    if (activeAccount) {
        ipsLoggedInEnterpriseId = activeAccount.idTokenClaims.email;
    }

    const [documents, setDocuments] = useState([]);

    let sno = 0;
    let location = useLocation();
    let uploadPath = location.pathname.split('/');
    let archiveFolderPath = `${uploadPath[2]}/${uploadPath[3]}/${uploadPath[4]}/${uploadPath[5]}`;

    let url = 'https://atci.lkm.qa.accenture.com/qa-apis/';

    const getDocuments = () => {
        if (process.env.NODE_ENV === 'development') {
            url = 'http://localhost:3021';
        }
        axios.get(url,
            {
                headers: {
                    'Authorization': localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                }
            })
            .then(res => {
                setDocuments(res.data.results);
            })
            .catch(err => console.log(err));
    }

    useEffect(() => {
        getDocuments();
    }, [])

    return (
        <div>
           
            {(trackAccess?.['full-access']?.includes(ipsLoggedInEnterpriseId)
                || newTrackAccess?.[uploadPath[4]]?.includes(ipsLoggedInEnterpriseId)) &&
                <>
                    <br />
                    <Upload archiveStatus={1} getAllDocuments={getDocuments} folderPath={archiveFolderPath} />
                </>
            }
            <div>
                <br />
                {fetchError && <Alert severity="error" className="errorAlert"><b>Internal Server Error:</b> Please try again with a hard refresh. If the issue persists, contact the LIS team for further assistance.</Alert>}
                <table className="track-archive">
                    <tr>
                        <th>Sl.no</th>
                        <th>File Name</th>
                        <th>Modified By</th>
                    </tr>
                    {sno === 0 && documents.map((document, index) => {
                       
                        if (document.archived !== 0 && location.pathname.slice(8) === document.path) {
                            return <tr>
                                <td>{++sno}</td>
                                <td>{document.name}</td>
                                <td>{document.modified_by}</td>
                            </tr>
                        } return '';
                    })}
                    {sno === 0 && <tr><td colSpan={3} className="track-archive-msg">No documents found</td></tr>}
                </table>
            </div>
        </div>
    )
}